module.exports = __webpack_public_path__ + "static/media/playstore-3a.73699be8.png";